import { Box, styled } from '@mui/material';

import { ganttPxPerMs } from '../gantt.constants';

export const GanttOverCapacityAlert = styled<React.FC<{ from: number; to: number; left: number }>>(Box)`
    position: absolute;
    display: flex;
    width: ${({ from, to }) => (to - from) * ganttPxPerMs * 2}px;
    height: 100%;
    background-image: repeating-linear-gradient(
        -45deg,
        rgba(0, 0, 0, 0),
        rgba(0, 0, 0, 0) 2.9px,
        rgba(219, 67, 67, 1) 3px,
        rgba(219, 67, 67, 1) 6px
    );
    background-size: 8px 8px;
    background-position: top left;
    pointer-events: auto; // allow cursor hover
`;
